<div class="wrapper">
  <!--  WORKDAY HEADER  -->
  <div
    (click)="$event.stopPropagation(); triggerOpenDetailsPanel('workday', dailyReport)"
    class="workday-header flex items-center gap-[12px] cursor-pointer pb-[20px]"
  >
    <span class="workday-label">{{ workConditionLabel }}</span>
    <mat-icon class="workday-edit-icon" svgIcon="pencil-outline" />
  </div>

  <ng-container *ngFor="let widget of widgetConfig; trackBy: trackWidget">
    <!--  WEATHER  -->
    <ng-container *ngIf="widget.name === 'weather' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('weather')"
        [isExpanded]="expandedSection === 'weather'"
        [subheading]="(weather?.avgtemp ? weather?.avgtemp + '&deg;F' : '') + (weather?.condition?.text ?
    ' ' + weather?.condition?.text : '')"
        componentString="weather"
        heading="Weather"
        icon="daily-report-weather"
        id="weather"
      >
        <ng-container>
          <ng-container *ngIf="weather && Object.keys(weather)?.length > 0; else noWeatherData">
            <div (click)="$event.stopPropagation()" class="panel weather-panel">
              <app-weather-summary
                (click)="triggerOpenDetailsPanel('weather', weather)"
                [data]="weather"
              />
            </div>
          </ng-container>
          <ng-template #noWeatherData>
            <div class="no-data">
              No weather data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  BID ITEM  -->
    <ng-container *ngIf="widget.name === 'bid_items' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('bid-item')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'bid-item'"
        [itemCount]="bidItems?.length"
        [subheading]="bidItems?.length + ' item' + (bidItems?.length !== 1 ? 's' : '')"
        componentString="bid-item"
        heading="Bid item"
        icon="daily-report-bid-item"
        id="bid-item"
      >
        <ng-container>
          <ng-container *ngIf="bidItems?.length; else noBidItemData">
            <div (click)="$event.stopPropagation()" class="panel bid-items-panel">
              <ng-container
                *ngFor="let eachBidItem of bidItems"
              >
                <app-station-wise-bid-item-summary
                  (click)="eachBidItem.id !== selectedId && triggerOpenDetailsPanel('bidItem', eachBidItem)"
                  *ngIf="eachBidItem.stations !== undefined"
                  [class.selected]="eachBidItem.id === selectedId"
                  [data]="eachBidItem"
                />
                <app-multiline-bid-item-summary
                  (click)="eachBidItem.id !== selectedId && triggerOpenDetailsPanel('bidItem', eachBidItem)"
                  *ngIf="eachBidItem.lineItems !== undefined"
                  [class.selected]="eachBidItem.id === selectedId"
                  [data]="eachBidItem"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noBidItemData>
            <div class="no-data">
              No bid item data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  ITEM POSTINGS (AASHTO)  -->
    <ng-container *ngIf="widget.name === 'item-postings' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('item-postings')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'item-postings'"
        [itemCount]="bidItems?.length"
        [subheading]="bidItems?.length + ' item' + (bidItems?.length !== 1 ? 's' : '')"
        componentString="item-postings"
        heading="Item postings"
        icon="daily-report-bid-item"
        id="item-postings"
      >
        <ng-container>
          <ng-container *ngIf="bidItems?.length; else noItemPostingsData">
            <div
              (click)="$event.stopPropagation()"
              [class.collapsed]="!isItemPostingsPanelExpanded && bidItems?.length > 4"
              class="panel item-postings-panel"
            >
              <ng-container *ngFor="let eachBidItem of bidItems">
                <app-item-posting-summary
                  (click)="eachBidItem.id !== selectedId && triggerOpenDetailsPanel('item-postings', eachBidItem.bidItem)"
                  [class.selected]="eachBidItem.id === selectedId"
                  [data]="eachBidItem"
                />
              </ng-container>
            </div>
            <div
              (click)="isItemPostingsPanelExpanded = !isItemPostingsPanelExpanded; $event.stopPropagation()"
              *ngIf="bidItems?.length > 4"
              class="see-more text-type-9 flex"
            >
              {{ isItemPostingsPanelExpanded ? 'See less' : 'See more' }}
            </div>
          </ng-container>
          <ng-template #noItemPostingsData>
            <div class="no-data">
              No item postings available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  DELIVERY-USAGE  -->
    <ng-container *ngIf="widget.name === 'deliveries' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('delivery-usage')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'delivery-usage'"
        [itemCount]="deliveriesCount + usagesCount"
        [subheading]="(deliveriesCount + usagesCount) + ' item' + ((deliveriesCount + usagesCount) === 1 ? '' : 's')"
        componentString="delivery-usage"
        heading="Delivery & usage"
        icon="daily-report-material-delivery"
        id="delivery-usage"
      >
        <div (click)="$event.stopPropagation()">
          <ng-container *ngIf="(deliveriesCount + usagesCount) > 0; else noDeliveryUsageData">
            <mat-tab-group
              #deliveryUsageTabs
              [selectedIndex]="expandedSectionTabIndex"
              class="contents-tab-group"
            >
              <mat-tab
                [label]="'Delivery'"
              >
                <ng-container *ngIf="deliveriesCount; else noDeliveryData">
                  <div class="panel delivery-panel">
                    <ng-container *ngFor="let delivery of deliveries">
                      <app-material-delivery-and-usage-summary
                        (click)="delivery.id !== selectedId && triggerOpenDetailsPanel('delivery', delivery)"
                        [class.selected]="delivery.id === selectedId"
                        [data]="delivery"
                      />
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #noDeliveryData>
                  <div class="no-data">
                    No delivery available.
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab
                [label]="'Usage'"
              >
                <ng-container *ngIf="usagesCount; else noUsageData">
                  <div class="panel usage-panel">
                    <ng-container *ngFor="let usage of usages">
                      <app-material-delivery-and-usage-summary
                        (click)="usage.id !== selectedId && triggerOpenDetailsPanel('usage', usage)"
                        [class.selected]="usage.id === selectedId"
                        [data]="usage"
                      />
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #noUsageData>
                  <div class="no-data">
                    No usage available.
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </ng-container>
          <ng-template #noDeliveryUsageData>
            <div class="no-data">
              No delivery and usage available.
            </div>
          </ng-template>
        </div>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  MATERIAL-TESTING  -->
    <ng-container *ngIf="widget.name === 'testing' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('material-testing')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'material-testing'"
        [itemCount]="openExternalTestCount + closedExternalTestCount + internalMaterialTestingCount"
        [subheading]="openExternalTestCount + ' Open'+' '+  closedExternalTestCount + ' Closed' +' '+ internalMaterialTestingCount + ' Onsite'"
        componentString="material-testing"
        heading="Material testing"
        icon="daily-report-material-testing"
        id="material-testing"
      >
        <div (click)="$event.stopPropagation()">
          <ng-container
            *ngIf="(internalMaterialTestingCount + externalMaterialTestingCount) > 0; else noMaterialTestingData">
            <mat-tab-group
              #materialTestingTabs
              [selectedIndex]="expandedSectionTabIndex"
              class="contents-tab-group"
            >
              <mat-tab label="Offsite">
                <ng-container *ngIf="externalMaterialTestingCount; else noExternalData">
                  <ng-container *ngIf="materialTesting?.external?.openTests.length">
                    <div class="category-heading my-[20px] text-type-6">
                      Open :
                    </div>
                    <div
                      (click)="$event.stopPropagation()"
                      [class.collapsed]="!isOpenTestPanelExpanded && materialTesting?.external?.openTests?.length > 4"
                      class="panel open-external-testing-panel"
                    >
                      <ng-container *ngFor="let test of materialTesting?.external?.openTests">
                        <app-material-test-summary-external
                          (click)="test.id !== selectedId && triggerOpenDetailsPanel('externalTest', test)"
                          [class.selected]="test.id === selectedId"
                          [data]="test"
                        />
                      </ng-container>
                    </div>
                    <div
                      (click)="isOpenTestPanelExpanded = !isOpenTestPanelExpanded; $event.stopPropagation()"
                      *ngIf="materialTesting?.external?.openTests?.length > 4"
                      class="see-more text-type-9 flex"
                    >
                      {{ isOpenTestPanelExpanded ? 'See less' : 'See more' }}
                    </div>
                  </ng-container>
                  <ng-container *ngIf="materialTesting?.external?.closedTests?.length">
                    <div class="category-heading my-[20px] text-type-6">
                      Closed :
                    </div>
                    <div (click)="$event.stopPropagation()"
                         [class.collapsed]="!isClosedTestPanelExpanded && materialTesting?.external?.closedTests?.length > 4"
                         class="panel closed-external-testing-panel"
                    >
                      <ng-container *ngFor="let test of materialTesting?.external?.closedTests">
                        <app-material-test-summary-external
                          (click)="test.id !== selectedId && triggerOpenDetailsPanel('externalTest', test)"
                          [class.selected]="test.id === selectedId"
                          [data]="test"
                        />
                      </ng-container>
                    </div>
                    <div
                      (click)="isClosedTestPanelExpanded = !isClosedTestPanelExpanded; $event.stopPropagation()"
                      *ngIf="materialTesting?.external?.closedTests?.length > 4"
                      class="see-more text-type-9 flex"
                    >
                      {{ isClosedTestPanelExpanded ? 'See less' : 'See more' }}
                    </div>
                  </ng-container>
                </ng-container>
                <ng-template #noExternalData>
                  <div class="no-data">
                    No offsite tests available.
                  </div>
                </ng-template>
              </mat-tab>
              <mat-tab label="Onsite">
                <ng-container *ngIf="internalMaterialTestingCount; else noInternalData">
                  <div (click)="$event.stopPropagation()" class="panel internal-panel">
                    <ng-container *ngFor="let eachInternalTest of materialTesting?.internal?.['groupedInternalTests']">
                      <app-material-test-summary-internal
                        (click)="eachInternalTest.id !== selectedId && triggerOpenDetailsPanel('internalTest', eachInternalTest)"
                        [class.selected]="eachInternalTest.id === selectedId"
                        [data]="eachInternalTest"
                      />
                    </ng-container>
                  </div>
                </ng-container>
                <ng-template #noInternalData>
                  <div class="no-data">
                    No onsite tests available.
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </ng-container>
          <ng-template #noMaterialTestingData>
            <div class="no-data">
              No material testing data available.
            </div>
          </ng-template>
        </div>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  ISSUES  -->
    <ng-container *ngIf="widget.name === 'issues' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('issues')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'issues'"
        [itemCount]="issues?.length"
        [subheading]="issues?.length + ' item' + (issues?.length === 1 ? '' : 's')"
        componentString="issues"
        heading="Issues"
        icon="daily-report-issues"
        id="issues"
      >
        <ng-container>
          <ng-container *ngIf="issues?.length; else noIssuesData">
            <ng-container *ngIf="openIssues?.length">
              <div class="category-heading my-[20px] text-type-6">
                Open :
              </div>
              <div
                (click)="$event.stopPropagation()"
                [class.collapsed]="!isOpenIssuesPanelExpanded && openIssues?.length > 4"
                class="panel open-issues-panel"
              >
                <ng-container *ngFor="let issue of openIssues">
                  <app-issue-summary
                    (click)="triggerOpenDetailsPanel('issue', issue)"
                    [class.selected]="issue.id === selectedId"
                    [issue]="issue"
                  />
                </ng-container>
              </div>
              <div
                (click)="isOpenIssuesPanelExpanded = !isOpenIssuesPanelExpanded; $event.stopPropagation()"
                *ngIf="openIssues?.length > 4"
                class="see-more text-type-9 flex"
              >
                {{ isOpenIssuesPanelExpanded ? 'See less' : 'See more' }}
              </div>
            </ng-container>
            <ng-container *ngIf="closedIssues?.length">
              <div class="category-heading my-[20px] text-type-6">
                Closed :
              </div>
              <div (click)="$event.stopPropagation()"
                   [class.collapsed]="!isClosedIssuesPanelExpanded && closedIssues?.length > 4"
                   class="panel closed-issues-panel"
              >
                <ng-container *ngFor="let issue of closedIssues">
                  <app-issue-summary
                    (click)="triggerOpenDetailsPanel('issue', issue)"
                    [class.selected]="issue.id === selectedId"
                    [issue]="issue"
                  />
                </ng-container>
              </div>
              <div
                (click)="isClosedIssuesPanelExpanded = !isClosedIssuesPanelExpanded; $event.stopPropagation()"
                *ngIf="closedIssues?.length > 4"
                class="see-more text-type-9 flex"
              >
                {{ isClosedIssuesPanelExpanded ? 'See less' : 'See more' }}
              </div>
            </ng-container>
          </ng-container>
          <ng-template #noIssuesData>
            <div class="no-data">
              No issues data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  LABOR-EQUIPMENT  -->
    <ng-container *ngIf="widget.name === 'labor' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('labor-equipment')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'labor-equipment'"
        [itemCount]="laborCount + equipmentCount"
        [subheading]="laborCount + ' personnel,' + ' ' + equipmentCount + ' equipment'"
        componentString="labor-equipment"
        heading="Labor & equipment"
        icon="daily-report-labor-equipment"
        id="labor-equipment"
      >
        <div (click)="$event.stopPropagation()">
          <mat-tab-group
            #laborEquipmentTabs
            [selectedIndex]="expandedSectionTabIndex"
            class="contents-tab-group"
          >
            <mat-tab
              [label]="'Labor'"
            >
              <ng-container *ngIf="laborCount; else noLaborData">
                <div class="panel delivery-panel">
                  <ng-container *ngFor="let labor of labors">
                    <app-labor-summary
                      (click)="labor.id !== selectedId && triggerOpenDetailsPanel('labor', labor)"
                      [class.selected]="labor.id === selectedId"
                      [data]="labor"
                    />
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noLaborData>
                <div class="no-data">
                  No labor available.
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab
              [label]="'Equipment'"
            >
              <ng-container *ngIf="equipmentCount; else noEquipmentData">
                <div class="panel usage-panel">
                  <ng-container *ngFor="let equipment of equipments">
                    <app-labor-summary
                      (click)="equipment.id !== selectedId && triggerOpenDetailsPanel('equipment', equipment)"
                      [class.selected]="equipment.id === selectedId"
                      [data]="equipment"
                    />
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noEquipmentData>
                <div class="no-data">
                  No equipment available.
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>

      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!--  CONTRACTOR-LABOR-EQUIPMENT  -->
    <ng-container *ngIf="widget.name === 'contractor-labor-equipment' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('contractor-labor-equipment')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'contractor-labor-equipment'"
        [itemCount]="contractorCount + laborCount + equipmentCount"
        [subheading]="contractorCount + ' contractor' + (contractorCount !== 1 ? 's' : '') + ', ' + laborCount + ' personnel, ' + equipmentCount + ' equipment'"
        componentString="contractor-labor-equipment"
        heading="Contractor, labor & equipment"
        icon="daily-report-labor-equipment"
        id="contractor-labor-equipment"
      >
        <div (click)="$event.stopPropagation()">
          <mat-tab-group
            #cleTabs
            [selectedIndex]="expandedSectionTabIndex"
            (selectedTabChange)="onCleTabChange($event)"
            class="contents-tab-group"
          >
            <mat-tab [label]="'Contractor'">
              <ng-container *ngIf="contractorCount; else noContractorData">
                <div
                  (click)="$event.stopPropagation()"
                  [class.collapsed]="!isContractorPanelExpanded && contractors?.length > 4"
                  class="panel contractor-panel"
                >
                  <ng-container *ngFor="let contractor of contractors">
                    <app-cle-contractor-summary
                      (click)="contractor.id !== selectedId && triggerOpenDetailsPanel('cle-contractor', contractor)"
                      [class.selected]="contractor.id === selectedId"
                      [data]="contractor"
                    />
                  </ng-container>
                </div>
                <div
                  (click)="isContractorPanelExpanded = !isContractorPanelExpanded; $event.stopPropagation()"
                  *ngIf="contractors?.length > 4"
                  class="see-more text-type-9 flex"
                >
                  {{ isContractorPanelExpanded ? 'See less' : 'See more' }}
                </div>
              </ng-container>
              <ng-template #noContractorData>
                <div class="no-data">
                  No contractor available.
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab [label]="'Labor'">
              <ng-container *ngIf="laborCount; else noCLELaborData">
                <div
                  (click)="$event.stopPropagation()"
                  [class.collapsed]="!isLaborPanelExpanded && labors?.length > 4"
                  class="panel labor-panel"
                >
                  <ng-container *ngFor="let labor of labors">
                    <app-cle-labor-summary
                      (click)="labor.id !== selectedId && triggerOpenDetailsPanel('cle-labor', labor)"
                      [class.selected]="labor.id === selectedId"
                      [data]="labor"
                    />
                  </ng-container>
                </div>
                <div
                  (click)="isLaborPanelExpanded = !isLaborPanelExpanded; $event.stopPropagation()"
                  *ngIf="labors?.length > 4"
                  class="see-more text-type-9 flex"
                >
                  {{ isLaborPanelExpanded ? 'See less' : 'See more' }}
                </div>
              </ng-container>
              <ng-template #noCLELaborData>
                <div class="no-data">
                  No labor available.
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab [label]="'Equipment'">
              <ng-container *ngIf="equipmentCount; else noCLEEquipmentData">
                <div
                  (click)="$event.stopPropagation()"
                  [class.collapsed]="!isEquipmentPanelExpanded && equipments?.length > 4"
                  class="panel equipment-panel"
                >
                  <ng-container *ngFor="let equipment of equipments">
                    <app-cle-equipment-summary
                      (click)="equipment.id !== selectedId && triggerOpenDetailsPanel('cle-equipment', equipment)"
                      [class.selected]="equipment.id === selectedId"
                      [data]="equipment"
                    />
                  </ng-container>
                </div>
                <div
                  (click)="isEquipmentPanelExpanded = !isEquipmentPanelExpanded; $event.stopPropagation()"
                  *ngIf="equipments?.length > 4"
                  class="see-more text-type-9 flex"
                >
                  {{ isEquipmentPanelExpanded ? 'See less' : 'See more' }}
                </div>
              </ng-container>
              <ng-template #noCLEEquipmentData>
                <div class="no-data">
                  No equipment available.
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- ACTIVITIES -->
    <ng-container *ngIf="widget.name === 'activities' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('activities')"
        [data]="dailyReport?.reportDetails"
        [heading]="translations?.ReportActivity?.title || 'Activities'"
        [isExpanded]="expandedSection === 'activities'"
        [itemCount]="activities?.length"
        componentString="activities"
        icon="daily-report-activity"
        id="activities"
        subheading="{{activities?.length}} {{activities?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="activities?.length; else noActivitiesData">
            <div (click)="$event.stopPropagation()" class="panel activities-panel">
              <ng-container
                *ngFor="let eachActivity of activities; let i = index"
              >
                <app-activity-summary
                  (click)="eachActivity.id !== selectedId && triggerOpenDetailsPanel('activity', eachActivity, i+1)"
                  [class.selected]="eachActivity.id === selectedId"
                  [data]="eachActivity"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noActivitiesData>
            <div class="no-data">
              No activities data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- NOTES -->
    <ng-container *ngIf="widget.name === 'notes' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('notes')"
        [data]="dailyReport?.reportDetails"
        [heading]="translations?.ReportNotes?.title || 'Notes'"
        [isExpanded]="expandedSection === 'notes'"
        [itemCount]="notes?.length"
        componentString="notes"
        icon="daily-report-activity"
        id="notes"
        subheading="{{notes?.length}} {{notes?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="notes?.length; else noNotesData">
            <div (click)="$event.stopPropagation()" class="panel notes-panel">
              <ng-container
                *ngFor="let eachNote of notes; let i = index"
              >
                <app-notes-summary
                  (click)="eachNote.id !== selectedId && triggerOpenDetailsPanel('notes', eachNote, i+1)"
                  [class.selected]="eachNote.id === selectedId"
                  [data]="eachNote"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noNotesData>
            <div class="no-data">
              No notes data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- ACTIVITIES-CODES -->
    <ng-container *ngIf="widget.name === 'activity_codes' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('activity-codes')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'activity-codes'"
        [itemCount]="activityCodes?.length"
        componentString="activity-codes"
        heading="Activity IDs"
        icon="daily-report-bid-item"
        id="activity-codes"
        subheading="{{activityCodes?.length}} {{activityCodes?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="activityCodes?.length; else noActivityCodeData">
            <div (click)="$event.stopPropagation()" class="panel activity-code-panel">
              <ng-container
                *ngFor="let eachActivityCode of activityCodes; let i = index"
              >
                <app-activity-codes-summary
                  (click)="eachActivityCode.id !== selectedId && triggerOpenDetailsPanel('activity-codes', eachActivityCode)"
                  [class.selected]="eachActivityCode.id === selectedId"
                  [data]="eachActivityCode"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noActivityCodeData>
            <div class="no-data">
              No activity code data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- FORMS -->
    <ng-container *ngIf="widget.name === 'forms' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('forms')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'forms'"
        [itemCount]="forms?.length"
        componentString="forms"
        heading="Forms"
        icon="daily-report-forms"
        id="forms"
        subheading="{{forms?.length}} {{forms?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="forms?.length; else noFormsData">
            <div (click)="$event.stopPropagation()" class="panel forms-panel">
              <ng-container
                *ngFor="let form of forms"
              >
                <app-forms-summary
                  (click)="form.id !== selectedId && triggerOpenDetailsPanel('forms', form)"
                  [class.selected]="form.id === selectedId"
                  [data]="form"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noFormsData>
            <div class="no-data">
              No forms data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- CONTROL FORMS -->
    <ng-container *ngIf="widget.name === 'control_forms' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('control-forms')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'control-forms'"
        [itemCount]="controlForms?.length"
        componentString="control-forms"
        heading="Control point forms"
        icon="daily-report-forms"
        id="control-forms"
        subheading="{{controlForms?.length}} {{controlForms?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="controlForms?.length; else noFormsData">
            <div (click)="$event.stopPropagation()" class="panel forms-panel">
              <ng-container
                *ngFor="let form of controlForms"
              >
                <app-forms-summary
                  (click)="form.id !== selectedId && triggerOpenDetailsPanel('forms', form)"
                  [class.selected]="form.id === selectedId"
                  [data]="form"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noFormsData>
            <div class="no-data">
              No forms data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>

    <!-- TESTING FORMS -->
    <ng-container *ngIf="widget.name === 'testing_forms' && widget.display">
      <app-daily-report-expandable-block
        (click)="handleExpansion('testing-forms')"
        [data]="dailyReport?.reportDetails"
        [isExpanded]="expandedSection === 'testing-forms'"
        [itemCount]="testingForms?.length"
        componentString="testing_forms"
        heading="Testing forms"
        icon="daily-report-forms"
        id="testing-forms"
        subheading="{{testingForms?.length}} {{testingForms?.length === 1 ? 'entry' : 'entries'}} "
      >
        <ng-container>
          <ng-container *ngIf="testingForms?.length; else noFormsData">
            <div (click)="$event.stopPropagation()" class="panel forms-panel">
              <ng-container
                *ngFor="let form of testingForms"
              >
                <app-forms-summary
                  (click)="form.id !== selectedId && triggerOpenDetailsPanel('testForm', form)"
                  [class.selected]="form.id === selectedId"
                  [data]="form"
                />
              </ng-container>
            </div>
          </ng-container>
          <ng-template #noFormsData>
            <div class="no-data">
              No forms data available.
            </div>
          </ng-template>
        </ng-container>
      </app-daily-report-expandable-block>
      <hr class="divider" />
    </ng-container>
  </ng-container>
</div>
